import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function Problem() {
  const painPoints = ['Buscás recetas en TikTok que no tienen los ingredientes de acá', 'Delivery tres veces por semana porque no sabés qué hacer', 'Siempre las mismas tres recetas', 'Milanesas pálidas, papas blandas, pollo seco', 'La freidora guardada porque "no le agarré la mano"'];
  return <section className="py-20 md:py-32 bg-white relative" data-id="element-190">
      <div className="max-w-3xl mx-auto px-4" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-192">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-charcoal leading-tight mb-8" data-id="element-193">
            ¿Cuántas noches más vas a terminar pidiendo delivery?
          </h2>

          <div className="space-y-6 text-lg text-charcoal/80 leading-relaxed max-w-2xl mx-auto" data-id="element-194">
            <p data-id="element-195">
              Tenés una freidora de aire. La compraste con ganas. Pero nadie te
              enseñó a usarla para el día a día argentino real.
            </p>
            <p className="font-medium text-charcoal" data-id="element-196">
              No es falta de ganas. Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-cream rounded-2xl p-8 md:p-10 border border-sand shadow-sm mb-12" data-id="element-197">
          <ul className="space-y-5" data-id="element-198">
            {painPoints.map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-199">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-100 flex items-center justify-center mt-0.5" data-id="element-200">
                  <X size={14} className="text-red-600 stroke-[3]" data-id="element-201" />
                </div>
                <span className="text-charcoal/80 font-medium" data-id="element-202">{point}</span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-203">
          <p className="text-2xl md:text-3xl font-serif italic text-ember" data-id="element-204">
            ¿Y si esta fuera la última noche que terminás así?
          </p>
        </motion.div>
      </div>
    </section>;
}